import { useMemo, useState } from 'react'
import _ from 'lodash'

import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando dados',
}

const INITIAL_STATE = {
  posicoesEstoque: [],
  periodo: getPeriodoMesAtual(),
  loadingMessage: LOAD_MESSAGE.NONE,
  estoques: [],
  selectedEstoques: [],
  errorMessage: null,
  selectedStatus: [],
  selectedEmpresas: [],
}

export default function useRelatorioPosicaoDiaria() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions

      async getPosicoesEstoquesDiarioRelatorio(
        estoqueIds,
        company_ids,
        initialPeriod,
        finalPeriod,
      ) {
        let err = ''
        if (_.isEmpty(estoqueIds)) err = 'Selecione pelo menos um estoque'
        if (_.isEmpty(company_ids)) err = 'Selecione pelo menos uma empresa'
        if (initialPeriod == null) err = 'Selecione uma data inicial'
        if (finalPeriod == null) err = 'Selecione uma data final'
        if (err) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
        } else {
          await EstoqueHttp.getPosicoesEstoquesDiarioRelatorio(
            estoqueIds,
            company_ids,
            parseToMysqlFormat(initialPeriod),
            parseToMysqlFormat(finalPeriod),
          )
            .then(posicoesEstoque => {
              setState(prevState => ({
                ...prevState,
                posicoesEstoque: posicoesEstoque,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
        }
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
        } else {
          EstoqueHttp.getEstoques(selectedTp)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          // switch (name) {
          //   case 'selectedEstoque':
          //     prevState.loadingMessage = LOAD_MESSAGE.LOADING
          //     break
          //   case 'selectedEmpresas':
          //     prevState.loadingMessage = LOAD_MESSAGE.LOADING
          //     break
          //   default:
          //     break
          // }

          return { ...prevState }
        })
      },

      onDateChange(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: {
            dataInicial: dataInicial,
            dataFinal: dataFinal,
          },
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
